import React from "react";
import { Link, useLocation } from "react-router-dom";

const brandLogo = `${process.env.PUBLIC_URL || ""}/callmafia-logo.png`;

const Sidebar = ({ openNav, navHandler }) => {
  const location = useLocation(); // To check active route

  // Navigation Items Configuration
  const navItems = [
    { path: "/dashboard", label: "Overview", icon: "fas fa-th-large" },
    { path: "/extension-live-calls", label: "Extension Live Call", icon: "fas fa-phone-volume" },
    // { path: "/campaign-live-calls", label: "Campaigns Live Call", icon: "fas fa-headset" },
    { path: "/report-list", label: "Customer Detail", icon: "fas fa-address-book" },
    // { path: "/User-Counts", label: "Users Counts", icon: "fas fa-users" },
    { path: "/purchase-number-list", label: "DID", icon: "fas fa-list-ol" },
    { path: "/manage-user", label: "Number Manage", icon: "fas fa-cogs" },
    { path: "/delete-users", label: "Deleted Number", icon: "fas fa-trash-alt" },
    { path: "/Customer-Report", label: "Customer Report", icon: "fas fa-chart-line" },
    { path: "/ip-white-list", label: "IP Settings", icon: "fas fa-network-wired" },
    // { path: "/gatway", label: "Gateway", icon: "fas fa-server" },
    { path: "/extension-status", label: "Extensions Status", icon: "fas fa-signal" },
    { path: "/refulil-histry", label: "Refill History", icon: "fas fa-history" },
    // { path: "/api", label: "API", icon: "fas fa-code" },
    { path: "/send-notification", label: "Send Notification", icon: "fas fa-paper-plane" },
    // { path: "/twilio-number-fetch", label: "Twilio Number", icon: "fab fa-twitch" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <aside
        className={`custom-scrollbar fixed bottom-0 left-0 top-16 z-40 w-[280px] max-w-[85vw] overflow-y-auto border-r border-red-100 bg-white shadow-xl transition-transform duration-300 ease-in-out dark:border-red-950/40 dark:bg-black lg:w-64
        ${openNav ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}
        `}
      >
        <div className="border-b border-red-100 px-4 py-4 dark:border-red-950/40">
          <div className="flex items-center gap-3">
            <div className="overflow-hidden rounded-2xl border border-red-200 bg-white shadow-[0_10px_28px_rgba(127,29,29,0.12)] dark:border-red-900/40 dark:bg-neutral-950 dark:shadow-[0_14px_32px_rgba(127,29,29,0.28)]">
              <img
                src={brandLogo}
                alt="CallMafia logo"
                className="h-10 w-10 object-cover"
              />
            </div>
            <div>
              <p className="text-[11px] uppercase tracking-[0.22em] text-zinc-500 dark:text-zinc-400">Admin Panel</p>
              <h2 className="text-sm font-semibold">
                <span className="text-zinc-950 dark:text-white">CALL</span>
                <span className="ml-1 text-red-700 dark:text-red-500">MAFIA</span>
              </h2>
            </div>
          </div>
        </div>
        <div className="px-3 py-4">
          <ul className="space-y-1">
            {navItems.map((item, index) => (
              <li key={index}>
                <Link
                  to={item.path}
                  onClick={() => {
                    if (openNav && navHandler) {
                      navHandler();
                    }
                  }}
                  className={`group flex items-center rounded-xl p-3 text-sm font-medium transition-all duration-200
                    ${
                      isActive(item.path)
                        ? "bg-gradient-to-r from-red-700 to-red-900 text-white"
                        : "text-zinc-700 hover:bg-red-50 dark:text-zinc-300 dark:hover:bg-red-950/30 dark:hover:text-red-200"
                    }
                  `}
                >
                  <div className={`flex w-8 justify-center text-lg ${
                     isActive(item.path) ? "text-current" : "text-zinc-400 group-hover:text-red-700 dark:text-zinc-500 dark:group-hover:text-red-300"
                  }`}>
                    <i className={item.icon} />
                  </div>
                  <span className="ml-2 truncate">{item.label}</span>
                  {isActive(item.path) && (
                    <span className="ml-auto h-1.5 w-1.5 rounded-full bg-current" />
                  )}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </aside>

      {openNav && (
        <div 
          className="fixed inset-0 z-30 bg-black/50 backdrop-blur-sm transition-opacity lg:hidden"
          onClick={navHandler}
        />
      )}

      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 5px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: transparent;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background-color: #cbd5e1;
          border-radius: 20px;
        }
        .dark .custom-scrollbar::-webkit-scrollbar-thumb {
          background-color: #4b5563;
        }
      `}</style>
    </>
  );
};

export default Sidebar;
